import React from 'react';

interface CircleLabelProps {
    color: string;
    children: React.ReactNode;
    width?: number | string;
    height?: number | string;
}

const CircleLabel: React.FC<CircleLabelProps> = ({ children, color, height = 'auto', width = 'auto' }) => {
    const circleStyle = {
        backgroundColor: color,
        borderRadius: '50%',
        width: width,
        height: height,
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        color: 'white',
        fontSize: '16px',
    };

    return (
        <div style={circleStyle}>
            {children}
        </div>
    );
};

export default CircleLabel;